import React from 'react';
const ConversationSvg = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M20 47C29.9412 47 38 38.9412 38 29C38 19.0589 29.9412 11 20 11C10.0589 11 2 19.0589 2 29C2 31.7799 2.63018 34.4126 3.75545 36.763C4.1422 37.5709 4.27801 38.4862 4.04649 39.3514L3.3084 42.1101C2.72664 44.2843 4.71577 46.2733 6.89004 45.6916L9.64863 44.9534C10.5138 44.7221 11.4291 44.8578 12.237 45.2446C14.5874 46.3698 17.2201 47 20 47Z"
        stroke={color}
        strokeWidth="3"
      />
      <path
        d="M38 30.129C38.1496 30.0667 38.2979 30.0019 38.4448 29.9349C39.2595 29.5627 40.1737 29.4234 41.0388 29.655L42.1101 29.9416C44.2842 30.5232 46.2732 28.5342 45.6916 26.3601L45.405 25.2888C45.1734 24.4237 45.3127 23.5095 45.6849 22.6948C46.5293 20.846 47 18.7904 47 16.625C47 8.54784 40.4523 2 32.375 2C26.2948 2 21.0813 5.71023 18.875 10.9901"
        stroke={color}
        strokeWidth="3"
      />
      <path
        d="M12.166 29H12.1863M20.0201 29H20.0404M27.8749 29H27.8951"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ConversationSvg;
